import Pristine from 'pristinejs';
import { closeAllUtilityPopups, closeSideNav, openUtilityPopup } from '../popups/utils';
import { getHTML, getUtilityPopupContainer } from '../popups/utility-popups';
import newValidator, { FormValidationError } from '../validation';
import triggerEvent, { ErrorEvent, ErrorType, GAEventName } from '../analytics/ga/events';

async function onSaveSearchProvideName( event: Event ) {
    const saveElement = event.target as HTMLElement;

    const dataAtTimeOfSaving = {
        saveProperty: saveElement.dataset.saveProperty,
        saveValue: saveElement.dataset.saveValue,
        saveMeta: saveElement.dataset.saveMeta,
        saveDisplayname: '',
    };

    const close = function() {
        closeAllUtilityPopups();
        const popup = document.querySelector( '.popup__container--provide-search-name' ) as HTMLElement;
        popup.remove();
        window.dispatchEvent( new CustomEvent( 'twc:popup:close-property-search-provide-name', { bubbles: true } ) );
    };

    let validator: Pristine | null = null;

    const patternParts = [
        '0-9',
        'A-Za-z',
        'À-ÖØ-öø-ÿ', // latin character set
        '\u0104\u0106\u0118\u0141\u0143\u00D3\u015A\u0179\u017B\u0105\u0107\u0119\u0142\u0144\u00F3\u015B\u017A\u017C', // Polish character set
    ];

    const pattern = new RegExp( `^[${patternParts.join()}\\s.,&-]{5,50}$` );

    const validateInput = ( value: string ): boolean => {
        return pattern.test( value.trim() );
    };

    const onSubmit = function( submitEvent: SubmitEvent ) {
        submitEvent.preventDefault();

        validator.reset();

        const valid = validator.validate();
        const errors: Array<FormValidationError> = validator.getErrors();

        if ( errors.length > 0 ) {
            errors.forEach( ( err: FormValidationError ) => {
                triggerEvent<ErrorEvent>( GAEventName.Error, {
                    'error_type': ErrorType.ErrForm,
                    'error_message': err.errors[ 0 ],
                    'engaged_target': err.input.value,
                    'engaged_element': err.input.name,
                } );
            } );
        }

        if ( !valid ) {
            return;
        }

        const form = submitEvent.target as HTMLFormElement;

        const input = form.querySelector( 'input' );

        if ( !input ) {
            throw new Error( 'failed finding input in form' );
        }

        const value = input.value.trim();
        const formGroup = form.querySelector( '.form-group' );

        if ( !formGroup ) {
            throw new Error( 'failed to find form group element' );
        }

        const inputValid = validateInput( value );

        if ( !inputValid ) {
            formGroup.classList.add( 'pristine-has-danger' );

            const existingErr = formGroup.querySelector( '.error-message' );

            if ( existingErr ) {
                existingErr.remove();
            }

            const err = document.createElement( 'label' );
            err.className = 'pristine-error error-message';
            err.innerHTML = input.dataset.errorMessage as string;

            formGroup.appendChild( err );
            return;
        }

        dataAtTimeOfSaving.saveDisplayname = value;

        close();

        document.dispatchEvent( new CustomEvent( 'twc:saveable', {
            bubbles: true,
            detail: {
                element: saveElement,
                data: dataAtTimeOfSaving,
            },
        } ) );
    };

    const init = function( form: HTMLFormElement ) {
        if ( !validator ) {
            validator = newValidator( form );

            const input = form.querySelector( 'input' ) as HTMLInputElement;

            validator.addValidator( input, validateInput, input.dataset.errorMessage, 2, false );
        }

        form.addEventListener( 'submit', onSubmit );
    };

    const popup = await getHTML( 'search-name-popup' );

    getUtilityPopupContainer().appendChild( popup );

    const closeButton = popup.querySelector( '.popup__close' );

    if ( closeButton ) {
        closeButton.addEventListener( 'click', close );
    }

    const form = popup.querySelector( 'form' );

    if ( !form ) {
        throw new Error( 'failed to find form' );
    }

    init( form );

    await closeSideNav();

    closeAllUtilityPopups( false );

    openUtilityPopup( popup );

    const input = form.querySelector( 'input[name=displayName]' ) as HTMLInputElement;

    if ( input ) {
        input.focus();
    }
}

export default onSaveSearchProvideName;
